import { getAction,deleteAction ,putAction,postAction} from '../http'

export default {
  //分页查询项目表
  list(params = {}) {
    return getAction('/api/design/project/list',params);
  },
  //批量delete
  deleteBatch(params = {}) {
    return deleteAction('/api/design/project/deleteBatch',params);
  },
  //id删除
  delete(params = {}) {
    return deleteAction('/api/design/project/delete',params);
  },
  // 添加项目
  add(params = {}) {
    return postAction('/api/design/project/add',params)
  },

  //标签查询
  tagList(params = {}) {
    return getAction('/api/design/viewTagNum/list?column=num&order=desc&limit(0,10)',params);
  },

  //项目标签查询
  projectTagList(params = {}) {
    return getAction('/api/design/view_project_tag_num/list?column=num&order=desc',params);
  },
  
  //组件标签查询
  componentTagList(params = {}) {
    return getAction('/api/design/view_component_tag_num/list?column=num&order=desc&limit(0,10)',params);
  },

  // 添加标签
  addTag(params = {}){
    return postAction('/api/design/tag/add',params)
  },

  edit(params = {}) {
    return putAction('/api/design/project/edit',params);
  },

  queryById(params = {}){
    return getAction('/api/design/project/queryById',params);
  }
}